import React, { Fragment, useState, useEffect } from 'react';
import { Col, Button } from "reactstrap";
import { SelectForm } from "../../Basicos/index";
import { axiosApi } from '../../Basicos/axiosInstances';

const FiltrosCiclo = ({ novoOnClick, filtros, dados, setDadosFiltrados, valoresFiltro, setValoresFiltro }) => {
    const { periodos_letivos, semestres } = filtros

    const [turmasOptions, setTurmasOptions] = useState([]);

    const periodosOptions = periodos_letivos && periodos_letivos.map(p => ({ value: p.id, label: p.descricao }))
    const semestresOptions = semestres && semestres.map(s => ({ value: s.id, label: s.descricao }))

    const style = {
        col: { xs: 12, md: 3, sm: 3, lg: 3, xl: 3 }
    }

    useEffect(() => {
        if (valoresFiltro.periodo_letivo_id && valoresFiltro.semestre_id) {
            getTurmas(valoresFiltro.periodo_letivo_id, valoresFiltro.semestre_id);
        } else {
            setTurmasOptions([]);
        }
    }, [valoresFiltro.periodo_letivo_id, valoresFiltro.semestre_id]);

    const getTurmas = async (periodoId, semestreId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/filtro-turmas-semestre?periodo_letivo_id=${periodoId}&semestre_id=${semestreId}`);
            setTurmasOptions(data.map(element => ({ label: element.descricao, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeSelect = (nome, valor) => {
        let novosValores = { ...valoresFiltro, [nome]: valor };

        if (nome === 'periodo_letivo_id' || nome === 'semestre_id') {
            novosValores.turma_id = undefined;
        }

        setValoresFiltro(novosValores);

        let dadosFiltrados = dados;

        if (novosValores.periodo_letivo_id) {
            dadosFiltrados = dadosFiltrados.filter(d => !('periodo_letivo_id' in d) || d.periodo_letivo_id === novosValores.periodo_letivo_id);
        }
        if (novosValores.semestre_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.semestre_id === novosValores.semestre_id);
        }
        if (novosValores.turma_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.turma_id === novosValores.turma_id);
        }

        setDadosFiltrados(dadosFiltrados);
    }

    return (
        <Fragment>
            <SelectForm
                label="Período Letivo"
                name="periodo_letivo_id"
                placeholder="Período"
                options={periodosOptions}
                onChange={onChangeSelect}
                value={periodosOptions && periodosOptions.find(option => (option.value === valoresFiltro.periodo_letivo_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Semestre"
                name="semestre_id"
                placeholder="Semestre"
                options={semestresOptions}
                value={semestresOptions && semestresOptions.find(option => (option.value === valoresFiltro.semestre_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Turma"
                name="turma_id"
                placeholder="Turma"
                options={turmasOptions}
                value={turmasOptions && turmasOptions.find(option => (option.value === valoresFiltro.turma_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2"
                    onClick={() => {
                        setValoresFiltro({
                            periodo_letivo_id: undefined,
                            semestre_id: undefined,
                            turma_id: undefined
                        });
                        setDadosFiltrados(dados);
                    }}>Limpar</Button>
            </Col>
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2" onClick={novoOnClick}>Novo</Button>
            </Col>
        </Fragment >)
}

export default FiltrosCiclo;
